"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonMultiSelect = void 0;
const index_1 = require("../index");
const react_1 = __importDefault(require("react"));
const index_2 = require("../../icons/index");
const lodash_1 = require("lodash");
/**
 * @deprecated - this component is being deprecated in favor of ButtonGroupMulti.
 */
const ButtonMultiSelect = ({ values, onAdd, onRemove, options, ButtonProps = {}, showCheckmarks = true, }) => {
    return (react_1.default.createElement(react_1.default.Fragment, null, options.map((option) => {
        const isSelected = values.map(({ value }) => value).includes(option.value);
        return (react_1.default.createElement(index_1.Button, { sx: {
                margin: '10px',
                '&:first-of-type': {
                    marginLeft: 0,
                },
                '&:last-of-type': {
                    marginRight: 0,
                },
                ...ButtonProps.sx,
            }, variant: isSelected ? 'contained' : 'muted', color: isSelected ? 'secondary' : undefined, startIcon: isSelected && showCheckmarks && react_1.default.createElement(index_2.Check, { "data-testid": "check-icon" }), disabled: option.disabled, key: option.value?.toString(), onClick: isSelected ? () => onRemove(option) : () => onAdd(option), ...(0, lodash_1.omit)(ButtonProps, ['sx']) }, option.label));
    })));
};
exports.ButtonMultiSelect = ButtonMultiSelect;
exports.default = exports.ButtonMultiSelect;
